import { Provider } from '@angular/core';

import { IrsRepositoryImpl } from '@app/data/repositories/ptrab/irs/irs.repository';
import { IRS_REPOSITORY } from '@app/domain/repositories/ptrab/irs/irs.repository.contract';

export const irsRepositoryProvider: Provider = {
  provide: IRS_REPOSITORY,
  useClass: IrsRepositoryImpl
};
